module.exports = __webpack_public_path__ + "img/camera-button.29c6e784.png";